import { render, staticRenderFns } from "./SourceConnectionDetails.vue?vue&type=template&id=5ff020bc&scoped=true"
import script from "./SourceConnectionDetails.vue?vue&type=script&lang=js"
export * from "./SourceConnectionDetails.vue?vue&type=script&lang=js"
import style0 from "./SourceConnectionDetails.vue?vue&type=style&index=0&id=5ff020bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff020bc",
  null
  
)

export default component.exports